const projects = [
  {
    title: "Affi-NN-ity",
    event: "RBC Borealis Let's Solve It",
    desc: "Affi-NN-ity is a screening pipeline that predicts how tightly a drug candidate binds to a target protein. It combines a graph model of the molecule with protein sequence embeddings through an attention layer, and runs as an app that screens candidates from the ZINC compound database.",
    links: [
      { label: "Code", href: "https://github.com/james-yu2005/Affi-NN-ity" },
      {
        label: "Paper",
        href: "https://drive.google.com/file/d/16rNCrhAMm4Fd2UMlL33rfnOpz-laIPnC/view?usp=sharing",
      },
    ],
  },
  {
    title: "Shi Jie",
    desc: "Shi Jie is an AI reading app for Chinese learners. It pairs a smart reader with aligned translations and Pinyin/Jyutping, a vocabulary graph that links words by meaning and radical, and spaced-repetition flashcards on top. It has around 20 regular users.",
    links: [
      { label: "Code", href: "https://github.com/james-yu2005/Shi-jie" },
      { label: "Site", href: "https://shi-jie.vercel.app/" },
    ],
  },
  {
    title: "Myrtle",
    desc: "Myrtle is a turtle-shaped desk assistant built on an ESP32-S3. It wakes on a keyword, talks back, and runs a small tool server on the device so it can reach services like Notion and Tavily. It sits on a 3D-printed pan-tilt mount driven by two servos.",
    links: [
      { label: "Code", href: "https://github.com/james-yu2005/Myrtle" },
      {
        label: "Demo",
        href: "https://drive.google.com/drive/folders/1IlDqskuTuBkrtfLz0PAOH1rQauz5ByKw",
      },
    ],
  },
  {
    title: "BabyGPT",
    desc: "BabyGPT is a small GPT written from scratch, with attention, rotary embeddings, and a stack of transformer blocks. It comes with its own byte-level BPE tokenizer, and both are trained on a corpus of medical flashcards.",
    links: [{ label: "Code", href: "https://github.com/james-yu2005/Mini-GPT" }],
  },
  {
    title: "UW Rez",
    desc: "UW Rez is a review site for Waterloo residences that ranks dorms by what you actually care about, like room type, amenities, and lifestyle. It also answers questions by searching through student comments.",
    links: [
      { label: "Code", href: "https://github.com/LGeoff31/uwdorm" },
      { label: "Site", href: "https://uwrez.vercel.app/" },
    ],
  },
  {
    title: "Posture Corrector",
    desc: "This wearable tracks head and torso angle with a filtered IMU and buzzes when you slouch. A webcam check also measures neck angle from video, and the device uses a custom PCB and a 3D-printed enclosure.",
    links: [
      { label: "Code", href: "https://github.com/james-yu2005/Posture-corrector" },
      {
        label: "Demo",
        href: "https://drive.google.com/drive/folders/1XhhxoisGqGbtTAvJfZo68UkWgdPwPm_9",
      },
    ],
  },
];

export default projects;
